import { render } from "./Footer.vue?vue&type=template&id=1f8929d2"
const script = {}

import exportComponent from "/home/temp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__